const getters = {
  getTemplateByID: (state) => (id) => {
    return state.templates.find((template) => template.id === parseInt(id))
  },
  getObjectByHouseID: (state) => (id) => {
    return state.objects.find((object) => object.house_id === parseInt(id))
  },
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js